export const RESET_WORKFLOW_STEPS = 'RESET'

export const SET_WORKFLOW_STEPS = 'SET_WORKFLOW_STEPS'
export const DELETE_WORKFLOW_STEP = 'DELETE_WORKFLOW_STEP'
export const DELETE_WORKFLOW_STEP_FULFILLED = 'DELETE_WORKFLOW_STEP_FULFILLED'
